// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1m507","title":"InfoRow_title__1h3iN"};